<template>
    <ion-app v-if="route.path == '/login'">
        <div class="background">
            <div class="login">
                <div class='login-title'>
                    安优查可视化平台
                </div>

                <el-form>
                    <div class='username'>
                        <img class="login-img" src="@/../public/assets/icon/username.png">
                        <div class="login-content">
                            <el-form-item>
                                <el-input v-model="form.username" placeholder="请输入账号" clearable />
                            </el-form-item>
                        </div>

                    </div>
                    <div class='password'>
                        <img class="login-img" src="@/../public/assets/icon/password.png">
                        <div class="login-content">
                            <el-form-item>
                                <el-input v-model="form.password" type="password" show-password placeholder="请输入密码"
                                    clearable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class='verification-code'>
                        <img class="login-img" src="@/../public/assets/icon/verification-code.png">
                        <div class="login-content-code">
                            <el-form-item>
                                <el-input v-model="form.verificationCode" placeholder="请输入验证码" clearable />
                            </el-form-item>
                        </div>
                        <div class="verification-code-img" style="cursor: pointer;" @click="refreshCode">
                            <SIdentify :identifyCode="identifyCode" />
                        </div>
                    </div>
                </el-form>

                <button class='login-button' @click="login">
                    登录
                </button>
            </div>
        </div>
    </ion-app>
</template>

<script setup>
import SIdentify from '@/components/SIdentify.vue';
import javaapi from '@/service/javaapi';
import { ElMessage } from 'element-plus';
import { onMounted, onActivated,ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
onMounted(() => {
    identifyCode.value = "";
    makeCode(identifyCodes, 4);
    window.addEventListener("load", () => {
        identifyCode.value = "";
        makeCode(identifyCodes, 4);
    });

})

onActivated(()=>{
    identifyCode.value = "";
    makeCode(identifyCodes, 4);
    window.addEventListener("load", () => {
        identifyCode.value = "";
        makeCode(identifyCodes, 4);
    });
    form.value.verificationCode = ''
})
// 图形验证码
let identifyCodes = "1234567890"
let identifyCode = ref('')

const randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min)
}

const makeCode = (o, l) => {
    identifyCode.value = "";
    for (let i = 0; i < l; i++) {
        identifyCode.value += o[
            randomNum(0, o.length)
        ];
    }
}

const refreshCode = () => {
    identifyCode.value = "";
    makeCode(identifyCodes, 4);
}


const login = async () => {
    //console.log(form.value)
    if (form.value.verificationCode != identifyCode.value) {
        ElMessage.error('验证码错误')
        return;
    }
    let query = {
        jsonText: {
            username: form.value.username,
            password: form.value.password,
        },
    }
    let result = await javaapi.postQuery(query,"/users/quickLogin");
    //console.log(result)

    if (result.status == '0') {
        ElMessage.error(result.msg)
        return;
    }
    if (result.status == '1') {
        ElMessage.success("登录成功")
        localStorage.setItem("token",result.data?.user_info.token)
        localStorage.setItem("user_id",result.data?.user_info.user_id)
        localStorage.setItem("organization_id",result.data?.user_info.organization_info.organization_id)
        localStorage.setItem("organization_name",result.data?.user_info.organization_info.organization_name)
        localStorage.setItem("longitude",result.data?.user_info.organization_region_info.longitude)
        localStorage.setItem("latitude",result.data?.user_info.organization_region_info.latitude)
        router.push({
            name: 'GISPage'
        });
        refreshCode();
        form.value.verificationCode = ''

    }



}

const form = ref({
    username: "",
    password: "",
    verificationCode: "",
})
</script>

<style scoped>
.el-input {
  width: 100% !important;
}
.background {
    width: 100%;
    height: 100%;
    background-image: url(@/../public/assets/backgroundImg/login-background.png);
    background-size: 100% 100%;
}

.login {
    top: 26%;
    left: 32%;
    width: 36%;
    height: 48%;
    background-image: url(@/../public/assets/backgroundImg/leftInstitutionPic.png);
    background-size: 100% 100%;
    position: absolute;
}

.login-title {
    font-size: calc(40 / 1080 * 100vh);
    text-align: center;
    font-family: YouSheBiaoTiHei-Bold, YouSheBiaoTiHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 28px;
    top: 10%;
    width: 100%;
    height: 20%;
    position: absolute;
}

.username {
    top: 25%;
    width: 70%;
    left: 15%;
    height: 15%;
    /* background-color: #FFFFFF; */
    position: absolute;
}

.password {
    top: 40%;
    width: 70%;
    left: 15%;
    height: 15%;
    /* background-color: #FFFFFF; */
    position: absolute;
}

.verification-code {
    top: 55%;
    width: 70%;
    left: 15%;
    height: 15%;
    /* background-color: #FFFFFF; */
    position: absolute;
}

.login-img {
    top: 15%;
    position: absolute;
}

.login-button {
    cursor: pointer;
    top: 75%;
    left: 25%;
    width: 50%;
    height: 10%;
    border-style: none;
    background: linear-gradient(173deg, #40CFE8 0%, #2C91F2 100%);
    border-radius: 30px 30px 30px 30px;
    opacity: 1;
    text-align: center;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 23px;
    background-color: #2C91F2; 
    position: absolute;
}

.login-content {
    width: 90%;
    left: 10%;
    top: 15%;
    height: 100%;
    position: absolute;
}

.login-content-code {
    width: 50%;
    left: 10%;
    top: 15%;
    position: absolute;
}

.verification-code-img {
    width: 30%;
    left: 70%;
    top: 15%;
    height: 90%;
    position: absolute;
    /* background-color: #FFFFFF; */
}


.el-input__wrapper {

    border-radius: 5px 5px 5px 5px !important;
    opacity: 1 !important;
    border: 1px solid #2C91F2 !important;

}
</style>